import './instrument' // Sentry — must load before anything else (see file for why)
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ConvexAuthProvider } from '@convex-dev/auth/react'
import ErrorBoundary from './components/ErrorBoundary'
import App from './App'
import { convex } from './lib/convexClient'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ConvexAuthProvider client={convex}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ConvexAuthProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
